/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ReferencedEntityNullableLongDto
 */
export interface ReferencedEntityNullableLongDto {
    /**
     * 
     * @type {number}
     * @memberof ReferencedEntityNullableLongDto
     */
    id: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReferencedEntityNullableLongDto
     */
    $type?: ReferencedEntityNullableLongDtoTypeEnum;
}


/**
 * @export
 */
export const ReferencedEntityNullableLongDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoReferencedEntityNullableLongDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ReferencedEntityNullableLongDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ReferencedEntityNullableLongDtoTypeEnum = typeof ReferencedEntityNullableLongDtoTypeEnum[keyof typeof ReferencedEntityNullableLongDtoTypeEnum];


/**
 * Check if a given object implements the ReferencedEntityNullableLongDto interface.
 */
export function instanceOfReferencedEntityNullableLongDto(value?: unknown): value is ReferencedEntityNullableLongDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ReferencedEntityNullableLongDtoTypeEnum)[0];
}

export function ReferencedEntityNullableLongDtoFromJSON(json: any): ReferencedEntityNullableLongDto {
    return ReferencedEntityNullableLongDtoFromJSONTyped(json, false);
}

export function ReferencedEntityNullableLongDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferencedEntityNullableLongDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ReferencedEntityNullableLongDtoToJSON(value?: ReferencedEntityNullableLongDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        '$type': value.$type,
    });
}

